export default __webpack_public_path__ + "static/media/80.6fa37b75.svg";